import { render, staticRenderFns } from "./LocalCentralButtons.vue?vue&type=template&id=1e2fbf55&"
import script from "./LocalCentralButtons.vue?vue&type=script&lang=js&"
export * from "./LocalCentralButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports